import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type DenialType = 'role' | 'module' | undefined;

interface AccessDeniedState {
  isAccessDenied: boolean;
  denialType: DenialType;
}

const initialState: AccessDeniedState = {
  isAccessDenied: false,
  denialType: undefined,
};

const accessDeniedSlice = createSlice({
  name: 'accessDenied',
  initialState,
  reducers: {
    showAccessDenied: {
      reducer: (state, action: PayloadAction<DenialType>) => {
        state.isAccessDenied = true;
        state.denialType = action.payload;
      },
      prepare: (denialType?: DenialType) => ({
        payload: denialType,
      }),
    },
    hideAccessDenied: (state) => {
      state.isAccessDenied = false;
      state.denialType = undefined;
    },
  },
});

export const { showAccessDenied, hideAccessDenied } = accessDeniedSlice.actions;
export default accessDeniedSlice.reducer;
